import { useEffect, useState,useContext } from "react";
import $ from "jquery";
import {Card,Button,Form} from 'react-bootstrap';
import {
    useNavigate
} from "react-router-dom";
import Alert from 'react-bootstrap/Alert';
import UserContext from "../../contexts/UserContext";


const Feedback = () => {
const navigate = useNavigate();

const [feedbackDates,setFeedbackDates] = useState([]);   
const [feedbackMenu,setFeedbackMenu] = useState([]);  
const [feedbackDate,setFeedbackDate] = useState(null); 
const [selectedFeedbackMenu,setSelectedFeedbackMenu] = useState([]);  
const [feedbackType,setFeedbackType] = useState('quantity'); 
const [message,setMessage] = useState(null);
const {user,setUser} = useContext(UserContext);


async function getData(userId){
    await $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
        if(response && response.user){
           setUser(response.user);
        }else{
          setUser(null)
          navigate("/login",{state: { message: response.message }})
        }

      },
      error: function(err){
          console.log("error")
          console.log(err)
      }
  })
  }

useEffect(()=>{
    try{
    if(!user && localStorage.getItem('userSession')){
      getData(JSON.parse(localStorage.getItem('userSession')))
    }else{
      if(!user){
        navigate("/login")
      }
    }
  }catch(e){
    if(!user){
      navigate("/login")
    }
  }
  },[])

const getDataTillNow = async () => {
    await $.ajax({
        type:"GET",
        url:process.env.REACT_APP_API_URL+"/getFeedbackDates",
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
         success : function(response){
          if(response){
             setFeedbackDates(response.dates);
             setFeedbackMenu(response.menu);
          }else{
            navigate("/login",{state:{message:"Please Login !"}})
          }
  
        },
        error: function(err){
            console.log("error")
            console.log(err)
            navigate("/login",{state:{message:"Something went wrong !"}})
        }
    })
}

const getMenuForDate = async (e) => {
    const weekDays = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    setSelectedFeedbackMenu(feedbackMenu[0].days[weekDays.indexOf(e.target.value.split(" ")[0])-1])
    setFeedbackDate(e.target.value)
}

const submitQuantityData = async (e) => {
    e.preventDefault();
    let items = [];
    const inputElements=e.target.querySelectorAll('input')
    const inputNames = Array.from(inputElements).map(input => input.name);
    const finalArr = [...new Set(inputNames)];
    const formData = new FormData(e.target);

        for(let i in finalArr){
            items.push({[finalArr[i]]:formData.get(finalArr[i])})
        }
        if(e.target.comments){
            items.push({comments:e.target.comments.value})
        }
        await $.ajax({
            type:"POST",
            url:process.env.REACT_APP_API_URL+"/submitFeedback",
            xhrFields: {
                withCredentials: true  // Include cookies
              },
              crossDomain: true, 
             data:{items,feedbackDate,feedbackType}, 
             success : function(response){
              if(response && response.message){
                setMessage(response.message)
              }else{
                navigate("/login",{state:{message:"Please Login !"}})
              }
      
            },
            error: function(err){
                console.log("error")
                console.log(err)
                navigate("/login",{state:{message:"Something went wrong !"}})
            }
        })
        e.target.reset();
}


const QuantityFeedbackCard = () => {
        const design = (<Card className={feedbackType==='quality'?'d-none':'d-block m-2 mt-3'}>
        <Card.Header>{feedbackDate}</Card.Header>
            <Card.Body className="cardBody">
                <Form onSubmit={submitQuantityData}>
                {
                    selectedFeedbackMenu.items && selectedFeedbackMenu.items.length>0 && feedbackType?selectedFeedbackMenu.items.map((item,i) => {
                        return <>
                        <Card.Title>{item}</Card.Title>
                                <Card.Text className="d-flex justify-content-around">
                                <Form.Check
                                    type='radio'
                                    label='Less'
                                    name={item}
                                    value='less'
                                />
                                <Form.Check // prettier-ignore
                                    type='radio'
                                    label='Adequate'
                                    name={item}
                                    value='adequate'
                                />
                                <Form.Check // prettier-ignore
                                    type='radio'
                                    label='More'
                                    name={item}
                                    value='more'
                                />
                                </Card.Text> 
                            </>
                    }):null
                }

                <Button className="mt-4" variant="primary" type='submit'>Submit</Button>
                </Form>
            </Card.Body>
        </Card>)
        return design;
}

const QualityFeedbackCard = () => {
    const design = (<Card className={feedbackType==='quantity'?'d-none':'d-block m-2 mt-3'}>
    <Card.Header>{feedbackDate}</Card.Header>
        <Card.Body className="cardBody">
            <Form onSubmit={submitQuantityData}>
            {
                selectedFeedbackMenu.items && selectedFeedbackMenu.items.length>0 && feedbackType?selectedFeedbackMenu.items.map((item,i) => {
                    return <>
                    <Card.Title>{item}</Card.Title>
                            <Card.Text className="d-flex justify-content-around quality">
                            <Form.Check // prettier-ignore
                                type='radio'
                                label='Needs Improvement'
                                name={item}
                                value='needsImprovement'
                            />
                            <Form.Check // prettier-ignore
                                type='radio'
                                label='Eatable'
                                name={item}
                                value='eatable'
                            />
                            <Form.Check // prettier-ignore
                                type='radio'
                                label='Tasty'
                                name={item}
                                value='tasty'
                            />
                            </Card.Text> 
                        </>
                }):null
            }
            <Form.Group>
            <Form.Label>Comments : </Form.Label>
            <Form.Control as="textarea" name='comments' placeholder="Describe your feedback if any"/>
            </Form.Group>

            <Button className="mt-4" variant="primary" type='submit'>Submit</Button>
            </Form>
        </Card.Body>
    </Card>)
    return design;
}

    useEffect(() => {
        getDataTillNow();
    },[])

    const design = (
        <>
        {message?<Alert key='success' variant='success' >{message} !</Alert>:null}
            <Form.Select style={{width:'90%'}} className="d-flex m-3 mt-4" aria-label="Select Date" onChange={getMenuForDate}>
                <option>Select Date For Feedback</option>
                {
                    feedbackDates.length>0?
                    feedbackDates.map((feedbackDate,i) => {
                        return <option key={i} value={feedbackDate}>{feedbackDate}</option>
                    }):null
                }
            </Form.Select>
            {
                selectedFeedbackMenu && feedbackDate && selectedFeedbackMenu.items.length>0 && selectedFeedbackMenu.items && !selectedFeedbackMenu.items[0].label?
                <>
                <div className="d-flex m-2 mt-3 justify-content-around ">
                <Form.Check // prettier-ignore
                    type='radio'
                    label='Quantity'
                    name='feedbackType'
                    value='quantity'
                    onClick={()=>setFeedbackType('quantity')}
                    checked={feedbackType==="quantity"}
                />
                <Form.Check // prettier-ignore
                    type='radio'
                    label='Quality'
                    name='feedbackType'
                    value='quality'
                    onClick={()=>setFeedbackType('quality')}
                    checked={feedbackType==="quality"}
                />
                </div>
                {
                    feedbackType?
                    <>
                    <QuantityFeedbackCard />
                    <QualityFeedbackCard />
                    </>
                    :
                    null
                }
                </>
                :
                null
            }
        </>
    )
    return design;
}

export default Feedback;